import React, { useEffect } from 'react';
import { CustomTitle } from '@meitu/saas-ui/es/title';
import IconFont from '@meitu/xdesign-icon-font';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { ColorGroupProps } from '@meitu/xdesign-widgets/dist/colorGroup';
import './index.less';

interface ColorGroupWithTitleProps extends Omit<ColorGroupProps, 'children'> {
    title: React.ReactNode;
    fastSelectTransparent?: boolean;
}

const ColorGroupWithTitle: React.FC<ColorGroupWithTitleProps> = ({
    title,
    fastSelectTransparent = true,
    ...restProps
}) => {
    useEffect(() => {
        return () => {
            console.log('unmount ColorGroupWithTitle');
        };
    }, []);

    return (
        <ColorGroup {...restProps}>
            {({ PopupTrigger, FastPresetBtns }) => (
                <>
                    <CustomTitle leftNode={title} rightNode={PopupTrigger} />
                    <ul className="ColorGroupWithTitle-fast-colors">
                        {FastPresetBtns.filter((btn) => (fastSelectTransparent ? true : !btn.isTransparentPreset)).map(
                            (btn, index) => (
                                <li key={index}>
                                    {btn.node}
                                    {btn.isActived && <IconFont name="CheckBlack" fontSize={14} color="#ffffff" />}
                                </li>
                            ),
                        )}
                    </ul>
                </>
            )}
        </ColorGroup>
    );
};

export default ColorGroupWithTitle;
